import { z } from 'zod';
import {
  productTypeValues,
  schedulesSortByValues,
} from 'src/apis/transport-auction/mappings';
import {
  ascSortDirectionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import {
  preprocessAsArray,
  preprocessAsBoolean,
} from 'src/components/form/zod-utilities';
import { periodTypeValues } from 'src/pages/reporting/auctions/components/period-type';

export function getTransportAuctionsPageParamsForCalendarsSchema() {
  return z.object({
    calendarPeriodType: z.enum(periodTypeValues).default('WITHINDAY'),
    publicationDate: z.string().nullable().default(null),
    publicationDateEnd: z.string().nullable().default(null),
    auctionStartDate: z.string().nullable().default(null),
    auctionStartDateEnd: z.string().nullable().default(null),
    capacityCategory: z.preprocess(
      preprocessAsArray,
      z.array(z.enum(['Firm Types', 'Interruptible Types'])).default([])
    ),
    productRuntimeStart: z.string().nullable().default(null),
    productRuntimeEnd: z.string().nullable().default(null),
    sortAscending: z.preprocess(preprocessAsBoolean, z.boolean().default(true)),
    sortColumn: z.string().default('publishDate'),
    ...getPaginationSchema({ pageSize: 5 }).shape,
  });
}

export function getTransportAuctionsPageParamsForComfortBidsSchema() {
  return getPaginationSchema({ pageSize: 5 });
}

export function getTransportAuctionsPageParamsForReverseAuctionsSchema() {
  return z.object({
    sortColumn: z
      .enum([
        'status',
        'networkPointName',
        'tsoName',
        'quantityValue',
        'capacityCategory',
        'runtimeStart',
        'nextClose',
      ])
      .default('nextClose'),
    sortDirection: ascSortDirectionSchema,
    ...getPaginationSchema({ pageSize: 5 }).shape,
  });
}

export const schedulesPageParamsSchema = z.object({
  productType: z.enum(productTypeValues).default('WITHINDAY'),
  publicationDateStart: z.string().nullable().default(null),
  publicationDateEnd: z.string().nullable().default(null),
  openDateStart: z.string().nullable().default(null),
  openDateEnd: z.string().nullable().default(null),
  runtimeIntersectionFilterStart: z.string().nullable().default(null),
  runtimeIntersectionFilterEnd: z.string().nullable().default(null),
  slotIndex: z.coerce
    .number()
    .min(1, '{label} must be greater than or equal to 1.')
    .nullable()
    .default(null),
  sortBy: z.enum(schedulesSortByValues).default('PUBLICATION_DATE'),
  sortDirection: ascSortDirectionSchema.default('asc'),
  ...getPaginationSchema({ pageSize: 5 }).shape,
});
